import { IconProps } from '@models/icons';

function Add({
    size = 24, color = 'white', className, ...rest
}:IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"
            className={`icon ${className}`}
            {...rest} >
            <circle cx="11" cy="11.0002" r="8.25884" stroke={color} strokeWidth="1.48231"/>
            <path d="M11 7.14282V14.8571" stroke={color} strokeWidth="1.48231" strokeLinecap="round"/>
            <path d="M7.14453 11.0002L14.8588 11.0002" stroke={color} strokeWidth="1.48231" strokeLinecap="round"/>
        </svg>
    );
}

export default Add;
